const fromTo = (from, to) => {
  let result = []
  for (let i = from; i <= to; i++) {
    result.push(i)
  }
  return result
}

export default {
  CHECK_BOX: 101,
  CADASTRAL: 1,
  PARCEL_NO: 102,
  PARCEL_NO_INDEXES: [2, 3, 4],
  AREA: 6,
  OVP: 16,
  BPEJ: 15,
  BPEJ_AREA: 35,
  FIRST_PRICE: 36,
  PRICE_KU: 36,
  PRICE_KU_A: 37,
  PRICE_BPEJ: 38,
  PRICE_BPEJ_A: 39,
  PRICE_OWN: 40,
  PRICE_OWN_A: 41,
  FINAL_PRICE: 42,
  OWNER_NAME: 17,
  OWNER_ADDRESS: 18,
  SHARE: 19,
  TAGS: 28,
  OWNER_NEG_STATE: 34,
  TABLE_BY_PARCEL_NO_ROWSPAN_COL: [17, 18, 19, 29, 30, 31, 32, 33, 34],
  USER_PARCEL_DATA: fromTo(20, 28),
  USER_OWNER_DATA: fromTo(29, 34),
  PRICE_METHODS: fromTo(36, 41),
  PRICE_MASS_EDITING: fromTo(36, 44),
  BD_MAX: 44,
  SCROLL_COLUMN: 999
}



// WEBPACK FOOTER //
// ./src/config/tableLayoutIndexes.js